import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { SEED_PLANT_TYPES } from '../constants';

interface SeedsPlantTypeSelectProps {
  /** Tanlash mumkin bo'lgan ekin turlari; berilmasa barchasi ko'rsatiladi. */
  plantTypes?: readonly { readonly id: number; readonly labelKey: string }[];
}

export const SeedsPlantTypeSelect = ({
  plantTypes = SEED_PLANT_TYPES,
}: SeedsPlantTypeSelectProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const plantType = searchParams.get('plant_type');
  const defaultPlantType = String(plantTypes[0].id);
  const isAllowed = plantTypes.some(({ id }) => String(id) === plantType);

  useEffect(() => {
    if (!isAllowed) {
      setSearchParams(
        (prev) => {
          prev.set('plant_type', defaultPlantType);
          return prev;
        },
        { replace: true },
      );
    }
  }, [isAllowed, defaultPlantType, setSearchParams]);

  const handleChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('plant_type', value);
      return prev;
    });
  };

  return (
    <Select
      value={isAllowed ? (plantType as string) : defaultPlantType}
      onValueChange={handleChange}
    >
      <SelectTrigger className="h-10 w-[140px] rounded-lg border-border bg-card text-foreground">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {plantTypes.map(({ id, labelKey }) => (
          <SelectItem key={id} value={String(id)}>
            {t(labelKey)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
